<template>
  <div class="ecm__add-address">
    <el-dialog :title="title" :visible.sync="isShow" :before-close="handleCloseDialog" :show-close="false">
      <el-form
        class="ecm__add-address__form"
        :model="addressForm"
        :rules="rules"
        ref="addressForm"
        @submit.prevent.native="handleForm('addressForm')"
      >
        <div class="ecm__add-address__form-section">
          <Input
            :label="'Receiver'"
            :field="'receiver'"
            v-model="addressForm.receiver"
          />
          <Input
            :label="'Phone Number'"
            :field="'phone_number'"
            v-model="addressForm.phone_number"
          />
        </div>
        <div class="ecm__add-address__form-section">
          <Select
            :label="'Province'"
            :field="'province_id'"
            :options="provinces"
            v-model="addressForm.province_id"
          />
          <Select
            :label="'City'"
            :field="'city_id'"
            :isDisabled="cityDisabled"
            :options="cities"
            :isLoading="citiesOptionsLoading"
            v-model="addressForm.city_id"
          />
          <Input
            :label="'Postal Code'"
            :field="'postal_code'"
            :isReadOnly="true"
            v-model="addressForm.postal_code"
          />
        </div>
        <div class="ecm__add-address__form-section">
          <Input
            :label="'Detail'"
            :field="'detail_address'"
            :inputType="'textarea'"
            v-model="addressForm.detail_address"
          />
        </div>
        <div class="ecm__add-address__form-section">
          <Checkbox
            :label="'Main address'"
            :isDisabled="isDisabledChecked"
            v-model="addressForm.is_main_address"
          />
        </div>
        <div class="ecm__add-address__footer">
          <div class="ecm__add-address__footer-cancel" @click="handleCloseDialog">Cancel</div>
          <button class="ecm__add-address__footer-save" native-type="submit">Save and Use it</button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Input from '@/components/inputs/Input.vue'
import Select from '@/components/inputs/Select.vue'
import Checkbox from '@/components/inputs/Checkbox'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Add_Address',
  props: {
    title: {
      type: String,
      default: 'Add address'
    }
  },
  components: {
    Input,
    Select,
    Checkbox
  },
  data () {
    return {
      isShow: false,
      addressForm: {
        receiver: '',
        phone_number: '',
        province: '',
        province_id: '',
        city: '',
        city_id: '',
        postal_code: '',
        detail_address: '',
        is_main_address: true
      },
      rules: {
        receiver: [
          { required: true, message: 'Please input receiver', trigger: 'change' }
        ],
        phone_number: [
          { required: true, message: 'Please input phone number', trigger: 'change' }
        ],
        province_id: [
          { required: true, message: 'Please input province', trigger: 'blur' }
        ],
        city_id: [
          { required: true, message: 'Please input city', trigger: 'blur' }
        ],
        detail_address: [
          { required: true, message: 'Please input detail address', trigger: 'change' }
        ]
      },
      provinces: [],
      cityDisabled: true,
      cities: [],
      isDisabledChecked: false,
      citiesOptionsLoading: false,
      isLoading: true,
      addressId: null
    }
  },
  mounted () {
    this.handleFetchProvinces()
  },
  watch: {
    provinceId (val, oldVal) {
      if (val) {
        this.$data.cities = []
        if (oldVal) {
          this.$data.addressForm.postal_code = ''
          this.$data.addressForm.city = ''
          if (this.$data.addressForm.city_id) {
            this.$data.addressForm.city_id = ''
          }
        }
        const province = this.$data.provinces.find(province => province.value === val)
        if (province) {
          this.$data.addressForm.province = province.label
        } 
        this.handleFetchCities(val)
      }
    },
    cityId (val) {
      if (val) {
        const city = this.$data.cities.find(city => city.value === val)
        if (city) {
          this.$data.addressForm.postal_code = city.postal_code
          this.$data.addressForm.city = city.label
        }
      }
    }
  },
  computed: {
    provinceId () {
      return this.$data.addressForm.province_id
    },
    cityId () {
      return this.$data.addressForm.city_id
    },
    ...mapGetters({
      getAddress: 'address/getAddress'
    })
  },
  methods: {
    ...mapActions({
      fetchProvince: 'shipment/fetchProvince',
      fetchCity: 'shipment/fetchCity',
      createAddress: 'address/createAddress',
      updateAddress: 'address/updateAddress'
    }),
    handleForm (form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          if (this.$props.title.toLowerCase() === 'update address') {
            try {
              const resp = await this.updateAddress({ addressId: this.$data.addressId, ...this.$data.addressForm})
              if (resp.msg === 'success update address') {
                this.$message.success('Successfully changed address')
                if (this.$route.name === 'Setting') {
                  this.$emit('handleFetchAddresses')
                }
              }
            } catch (error) {
              console.log(error)
            }
          } else {
            try {
              const resp = await this.createAddress({ payload: this.$data.addressForm })
              if (resp.msg === 'success create address') {
                if (this.$route.name === 'Cart') {
                  this.$emit('handleCreateShipment')
                } else if (this.$route.name === 'Checkout') {
                  this.$emit('handleFetchShipmentsAddress')
                } else if (this.$route.name === 'Setting') {
                  this.$emit('handleFetchAddresses')
                }
              }
              this.$message.success('Successfully added new address')
            } catch (error) {
              console.log(error)
            }
          }
          this.handleCloseDialog()
        } else {
          return false
        }
      })
    },
    setIsDisabledChecked (val) {
      this.$data.isDisabledChecked = val
    },
    setIsShow (payload, key, addressId) {
      this.$data.isShow = payload
      if (key && key === 'update') {
        const { id, receiver, phone_number, province, province_id, city, city_id, postal_code, detail_address, is_main_address } = this.getAddress(addressId)
        this.addressForm = { ...this.addressForm, receiver, phone_number, province, province_id: province_id.toString(), detail_address, is_main_address }
        this.$data.addressId = id
        setTimeout(() => {
          this.addressForm['city'] = city
          this.addressForm['postal_code'] = postal_code
          this.addressForm['city_id'] = city_id.toString()
        }, 950);
      } else {
        this.addressForm.is_main_address = true
      }
    },
    handleCloseDialog () {
      this.handleResetFields()
      this.$data.isShow = false
    },
    handleCheckedItem (isChecked) {
      this.$data.addressForm.is_main_address = isChecked
    },
    handleResetFields () {
      this.$data.addressForm = {
        receiver: '',
        phone_number: '',
        province: '',
        province_id: '',
        city: '',
        city_id: '',
        postal_code: '',
        detail_address: '',
        is_main_address: true
      }
      this.$refs['addressForm'].resetFields()
    },
    handleFetchProvinces () {
      this.fetchProvince({
        cbSuccess: (resp) => {
          this.$data.provinces = resp
        },
        cbError: (err) => {
          console.log(err)
        }
      })
    },
    handleFetchCities (provinceId) {
      this.$data.cityDisabled = true
      this.$data.cityDisabled = false
      this.$data.citiesOptionsLoading = true
      this.fetchCity({
        provinceId,
        cbSuccess: (resp) => {
          this.$data.cities = resp
          setTimeout(() => {
            this.$data.citiesOptionsLoading = false
          }, 200)
        },
        cbError (err) {
          console.log(err)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__add-address {
  position: absolute;
  &::v-deep .el-dialog {
    // height: auto;
    width: 70%;
    .el-dialog__header {
      font-family: var(--font-family);
      .el-dialog__title {
        font-weight: 600;
        font-size: 20px;
        color: var(--color-blue-background);
      }
    }
    .el-dialog__body {
      padding: 10px 20px;
      .ecm__add-address__form {
        .ecm__add-address__form-section {
          display: flex;
          .el-form-item {
            padding: 2px;
            width: 100%;
          }
        }
      }
      .ecm__add-address__footer {
        padding: 20px 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        button, div {
          outline: none;
          border: none;
          font-size: 16px;
          margin-left: 10px;
          padding: 5px 15px;
          font-weight: 500;
          color: white;
          cursor: pointer;
          &.ecm__add-address__footer-cancel {
            background: rgba(255, 0, 0, 0.727);
          }
          &.ecm__add-address__footer-save {
            background: var(--color-blue-background);
          }
        }
      }
    }
  }
}
</style>
